import {
  state,
  trigger,
  transition,
  style,
  animate,
  type AnimationTriggerMetadata,
} from '@angular/animations';

export function slideAnimation(): AnimationTriggerMetadata {
  return trigger('slideInOut', [
    state(
      'in',
      style({
        width: '*',
      }),
    ),
    state(
      'out',
      style({
        width: '0px',
      }),
    ),
    transition('in => out', animate('400ms ease')),
    transition('out => in', animate('400ms ease')),
  ]);
}
